import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchbarService {
  private showSearchbarSource = new BehaviorSubject<boolean>(false);
  showSearchbar$ = this.showSearchbarSource.asObservable();

  setShowSearchbar(value: boolean) {
    this.showSearchbarSource.next(value);
  }
}